import { Configuration, PublicClientApplication, LogLevel } from '@azure/msal-browser';

// MSAL configuration - Force cache clear for SPA
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_MICROSOFT_CLIENT_ID || '900803bf-af1c-407e-a3f2-fe4b13dd94ab',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_MICROSOFT_TENANT_ID || 'ea0a46b7-760e-423b-a769-10b3c4af3a7d'}`,
    redirectUri: import.meta.env.VITE_FRONTEND_URL || window.location.origin,
    postLogoutRedirectUri: import.meta.env.VITE_FRONTEND_URL || window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage', // Changed from sessionStorage to force refresh
    storeAuthStateInCookie: false, // Disabled to prevent interference with JWT cookies
  },
  system: {
    allowRedirectInIframe: true, // Allow redirects in iframes for better incognito support
    loggerOptions: {
      loggerCallback: () => {
        // Completely disable all MSAL logging
      },
      logLevel: LogLevel.Error // Minimal logging
    }
  }
};

// Login request
export const loginRequest = {
  scopes: ['User.Read', 'email', 'profile', 'openid']
};

// Clear any existing MSAL cache on initialization
if (typeof window !== 'undefined') {
  localStorage.removeItem('msal.acquireTokenAccount');
  sessionStorage.clear();
}

// Create MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);

// Export for use in components
export default msalInstance;